// no itx for this file

import { ChannelType } from "../../models/ChannelType";
import SignalTypes from "../../models/SignalTypes";
import { NameListEntry } from "../NameEntryList";
import { ruleId } from "../ruleId";

export const buttonStatus: Array<NameListEntry> = [
  //////////////////////////////////////////////////////////////////////////////////
  // MDT

  {
    id: ruleId("Button-Status-Ignored-mdt"),
    signalType: SignalTypes.Ignored,
    functionNames: ["switch dark"],
    dpts: ["dpst-1-1"],
    manufacturers: ["m-0083"], // abb // busch jäger
  },
  {
    id: ruleId("Button-Status-ExternalButton-mdt"),
    signalType: SignalTypes.Switch,
    functionNames: ["external button"],
    dpts: ["dpst-1-1"],
    manufacturers: ["m-0083"], // abb // busch jäger
  },

  // "m-0085" == GVS

  {
    id: ruleId("Button-Status-gvs-2"),
    signalType: SignalTypes.Temperature_TargetStatus,
    functionNames: [
      /current setpoint adjustment.*status/,
      "value transmitter feedback", // LS Touch
    ],
    dpts: ["dpst-9-1"],
  },

  {
    manufacturers: ["m-0004"],
    id: ruleId("Button-Status-jung-1"),
    signalType: SignalTypes.Temperature_CurrentDisplay,
    // ⚠ ONLY-HERE: nicht in Actor/Status
    functionNames: [/actual temperature/],
    dpts: ["dpst-9-1"],
  },
 

  // {
  //   id: ruleId("Button-Status-SendValue"),
  //   signalType: SignalTypes.SendValueStatus,
  // ⚠ ONLY-HERE: nicht in Actor/Status
  //   functionNames: ["status"],
  //   conditions: ["send value"],
  //   dpts: undefined,
  // },

  // ignore
  {
    id: ruleId("Button-Status-Dummy1"),
    signalType: SignalTypes.Ignored,
    texts: ["dummy"],
    dpts: undefined, // mdt BE-TAS86Tx.02
  },

  {
    id: ruleId("Button-Status-Dummy2"),
    signalType: SignalTypes.Ignored,
    functionNames: ["dummy"],
    dpts: undefined, // mdt BE-TAS86Tx.02
  },

  {
    id: ruleId("Button-Status-ignore"),
    signalType: SignalTypes.Ignored,
    texts: ["master"], //	abb 6321/38-500
    dpts: ["dpst-1-1"],
  },
  {
    id: ruleId("Button-Status-ignoreSlave"),
    signalType: SignalTypes.Ignored,
    texts: ["slave"], //SBS/U6.0.1
    dpts: undefined, //dpst-1-1, dpst-9-1,dpst-20-102,dpst-1-100, dpst-5-1
  },

  // shutter
  {
    id: ruleId("Button-Status-shutter1"),
    signalType: SignalTypes.SlatPositionStatus,
    functionNames: ["slat"],
    dpts: ["dpst-5-1"],
  },

  // jalousie
  {
    id: ruleId("Button-Status-slat1"),
    signalType: SignalTypes.BlindPositionStatus,
    functionNames: ["position", "height"],
    excludeFunctionNames: ["slat"],
    dpts: ["dpst-5-1"],
  },

  // blind
  {
    id: ruleId("Button-Status-blind1"),
    signalType: SignalTypes.BlindPositionStatus,
    functionNames: ["position", "height"],
    excludeFunctionNames: ["dimming", "slat"],
    dpts: ["dpst-5-1"], ////
  },
  {
    id: ruleId("Button-Status-blind2"),
    signalType: SignalTypes.BlindTopStatus,
    functionNames: ["upper"],
    dpts: ["dpst-1-11", "dpst-1-1", "dpst-1-2"], // , 2CDG 110 065 R0011
  },
  {
    id: ruleId("Button-Status-blind3"),
    signalType: SignalTypes.BlindBottomStatus,
    functionNames: ["lower"],
    dpts: ["dpst-1-11", "dpst-1-1", "dpst-1-2"], // , 2CDG 110 065 R0011
  },
  {
    id: ruleId("Button-Status-blind4"),
    signalType: SignalTypes.BlindDirectionStatus,
    functionNames: ["direction", "shutter"],
    dpts: ["dpst-1-8"],
  },
  {
    id: ruleId("Button-Status-blind4_1"),
    signalType: SignalTypes.BlindDirectionStatus,
    functionNames: ["move up/down"], //	2CKA 006 115 A0503
    dpts: ["dpst-1-2"],
    manufacturers: ["m-0007"], // Busch-Jaeger Elektro
  },

  // heating

  //Heating
  {
    id: ruleId("Button-Status-heater-opmode1a"),
    signalType: SignalTypes.OperationMode,
    functionNames: ["select mode"],
    dpts: ["@ 1 byte"],
  },

  {
    id: ruleId("Button-Status-heater-opmode1b"),
    signalType: SignalTypes.OperationMode_Status,
    functionNames: ["status"],
    dpts: ["dpst-20-102"],
  },

  {
    id: ruleId("Button-Status-heater-opmode-forst"),
    signalType: SignalTypes.OperationMode_FrostProtection,
    // ⚠ ONLY-HERE: nicht in Actor/Status
    functionNames: ["mode"],
    texts: ["frost"],
    dpts: ["dpst-1-1"],
  },
  {
    id: ruleId("Button-Status-heater-opmode-comfort"),
    signalType: SignalTypes.OperationMode_Comfort,
    // ⚠ ONLY-HERE: nicht in Actor/Status
    functionNames: ["mode"],
    texts: ["comfort"],
    dpts: ["dpst-1-1"],
  },
  {
    id: ruleId("Button-Status-heater-opmode-night"),
    signalType: SignalTypes.OperationMode_Night,
    // ⚠ ONLY-HERE: nicht in Actor/Status
    functionNames: ["mode"],
    texts: ["night"],
    dpts: ["dpst-1-1"],
  },
  ////////////////////////////////////////////////////////////////////////
  // {
  //   id: ruleId("Button-Status-heater2a"),
  //   signalType: SignalTypes.Temperature_TargetComfortStatus,
  // ⚠ ONLY-HERE: nicht in Actor/Status
  //   texts: ["comfort"],
  //   functionNames: ["current setpoint", "control value", "set setpoint"],
  //   dpts: ["dpst-9-1", "dpst-9-2"],
  // },
  {
    id: ruleId("Button-Status-heater2b"),
    signalType: SignalTypes.Temperature_TargetStatus,
    functionNames: [/current.*setpoint/, "actual setpoint"],
    excludeFunctionNames: ["adjustment"], // JUNG LS Touch
    dpts: ["dpst-9-1", "dpst-9-2"],
  },
  {
    id: ruleId("Button-Status-heater2c"),
    signalType: SignalTypes.Temperature_TargetStatus,
    texts: [
      "actual set value",
      "set value display", // Buch // ABB 6321/38-500
      "temperature indicator", // Z41 Lite, MWE 9.12.2025. Es ist nicht 100% eindeutig, ab man die TargetTemperature oder die CurrentTemperature meint. aber für jetzt habe ich eben so entschieden
    ],
    dpts: ["dpst-9"],
  },
  {
    id: ruleId("Button-Status-heater2d"),
    signalType: SignalTypes.Temperature_TargetStatus,
    texts: ["input"],
    functionNames: ["setpoint"], // Jung Room controller 429D1ST
    excludeFunctionNames: ["shift", "adjustment"], // Jung Room controller 429D1ST, LS-Touch
    dpts: ["dpst-9"],
  },
  {
    id: ruleId("Button-Status-heater2g"),
    signalType: SignalTypes.Temperature_TargetStatus,
    texts: [/setpoint.*temp/], // Zennio ZVIZ35V3
    dpts: ["dpst-9-1"],
  },
  {
    id: ruleId("Button-Status-heater2e"),
    signalType: SignalTypes.Temperature_ValveStateStatus,
    texts: [
      "heating control value", //	abb 6321/38-500,
    ],
    excludeFunctionNames: ["output"], //	abb 6321/38-500,
    dpts: ["dpst-1-1"],
  },

  {
    id: ruleId("Button-Status-heater2f"),
    signalType: SignalTypes.Temperature_ControlValueStatus, //// geändert 11.2025 temperatur kann keine prozent sein !
    functionNames: ["status control value"],
    excludeFunctionNames: ["shift"],
    dpts: ["dpst-5-1"],
  },

  {
    id: ruleId("Button-Status-heater13"),
    signalType: SignalTypes.Temperature_Current,
    // ⚠ ONLY-HERE: nicht in Actor/Status
    texts: ["input"],
    functionNames: ["actual-temperature", "actual temperature"],
    dpts: ["dpst-9", "dpst-9-1"], //mdt BE-TAS86Tx.02
  },

  {
    id: ruleId("Button-Status-heater1_2"),
    signalType: SignalTypes.Temperature_Current,
    // ⚠ ONLY-HERE: nicht in Actor/Status
    excludeFunctionNames: ["setpoint"],
    functionNames: ["current"],
    dpts: ["dpst-9-1"],
  },
   {
    id: ruleId("Button-Status-temperaturemeasurement-1"),
    signalType: SignalTypes.Temperature_Current,
    functionNames: [/temperature value/],
    excludeFunctionNames: ["set"],
    dpts: ["dpst-9-1"],
  },
  {
    id: ruleId("Button-Status-heater1_3"),
    signalType: SignalTypes.Temperature_ValveStateStatus,
    functionNames: [
      "pump relay", //abb 2CDG 120 061 R0011
    ],
    dpts: ["dpst-1-1"],
  },

  //RGBW // RGB
  {
    id: ruleId("Button-Status-HSV_ColorValue-1"),
    signalType: SignalTypes.HSV_ColorValueStatus,
    // ⚠ ONLY-HERE: nicht in Actor/Status
    functionNames: ["hsv status"],
    excludeFunctionNames: ["on/off", "toggle", "hue", "saturation", "value (v)"],
    dpts: ["@ 3 bytes"],
  },
  {
    id: ruleId("Button-Status-HSV_HueValue-1"),
    signalType: SignalTypes.HSV_HueValueStatus,
    functionNames: ["hue"],
    dpts: ["dpst-5-3", "dpst-5-5", "dpst-5-1"],
  },

  {
    id: ruleId("Button-Status-RGB1"),
    signalType: SignalTypes.RGBBlueValueStatus,
    functionNames: ["blue brightness", /blue.*status/, "blue feedback"],
    excludeFunctionNames: ["absolute"],
    dpts: ["dpst-5-1"],
  },
  {
    id: ruleId("Button-Status-RGB2"),
    signalType: SignalTypes.RGBRedValueStatus,
    functionNames: ["red brightness", /red.*status/, "red feedback"],
    excludeFunctionNames: ["absolute"],
    dpts: ["dpst-5-1"],
  },
  {
    id: ruleId("Button-Status-RGB3"),
    signalType: SignalTypes.RGBWhiteValueStatus,
    functionNames: ["white brightness", "colour value white feedback"],
    excludeFunctionNames: ["absolute"],
    dpts: ["dpst-5-1"],
  },
  {
    id: ruleId("Button-Status-RGB4"),
    signalType: SignalTypes.RGBGreenValueStatus,
    functionNames: ["green brightness", /green.*status/, "green feedback"],
    excludeFunctionNames: ["absolute"],
    dpts: ["dpst-5-1"],
  },
  {
    id: ruleId("Button-Status-RGB5"),
    signalType: SignalTypes.HSV_SaturationValueStatus,
    functionNames: ["saturation"], //BE-GT2Tx.02
    dpts: ["dpst-5-1"],
  },
  {
    id: ruleId("Button-Status-RGB6"),
    signalType: SignalTypes.HSV_SaturationValueStatus,
    functionNames: ["value (v)"], //BE-GT2Tx.02
    dpts: ["dpst-5-1"],
  },
  {
    id: ruleId("Button-Status-RGB7"),
    signalType: SignalTypes.RGBValueStatus,
    functionNames: ["rgb brightness", "rgbw brightness", "rgbw status", "rgb status"], //BE-GT2Tx.02
    excludeFunctionNames: ["on/off", "toggle"],
    dpts: ["dpst-232-600"],
  },
  {
    id: ruleId("Button-Status-RGB7_1"),
    signalType: SignalTypes.RGBValueStatus6Byte,
    dpts: ["dpst-251-600"],
  },

  {
    id: ruleId("Button-Status-RGBW1"),
    signalType: SignalTypes.RGBValueStatus,
    functionNames: ["rgbw"],
    dpts: ["dpst-251-600"],
  },

  /// Tuneable white

  {
    id: ruleId("Button-Status-ColorTemperatureKelvinValue-2"),
    signalType: SignalTypes.ColorTemperatureKelvinStatus,
    //functionNames: ["status"], //Zennio Z35 	ZVIZ35V3W
    dpts: ["dpst-7-600"],
  },
  
  {
    id: ruleId("Button-Status-TunableWhite4a"),
    signalType: SignalTypes.ColorTemperaturePercentStatus,
    // ⚠ ONLY-HERE: nicht in Actor/Status
    functionNames: ["color temperature"], //	BE-TAS5504.01
    dpts: ["dpst-5-1"],
  },
  {
    id: ruleId("Button-Status-TunableWhite5"),
    signalType: SignalTypes.TunableWhiteTransitionValueStatus,
    functionNames: [/(color|colour) temp.*proportion/],
    dpts: ["dpst-5-1"],
  },

  // dimm
  {
    id: ruleId("Button-Status-Dimmer1"),
    signalType: SignalTypes.DimValueStatus,
    functionNames: ["brightness", "dim"],
    excludeFunctionNames: ["screen"],
    dpts: ["dpst-5-1"],
  },
   {
    id: ruleId("Button-Status-Dimmer2"),
    signalType: SignalTypes.DimValueStatus,
    texts: [/light.*percentage/], //Zennio Z35 	ZVIZ35V3W
    dpts: ["dpst-5-1"],
  },
  {
    id: ruleId("Button-Status-Diagnostic1"),
    signalType: SignalTypes.Diagnostic,
    functionNames: ["diagnosis"],
    dpts: ["dpst-16-0"],
  },
  {
    id: ruleId("Button-Status-Diagnostic2"),
    signalType: SignalTypes.Diagnostic,
    texts: ["diagnosis"],
    dpts: ["dpst-16-0"],
  },

  {
    id: ruleId("Button-Status-Diagnostic3"),
    signalType: SignalTypes.EnvironmentError,
    texts: ["message"],
    dpts: ["dpst-1-5"],
  },
  /// präsenzMelder
  {
    id: ruleId("Button-Status-Brightness1"),
    signalType: SignalTypes.Brightness_CurrentStatus,
    // ⚠ ONLY-HERE: nicht in Actor/Status
    texts: ["brightness"], //ABB 	CGD 006 132 R0342 Präsenzmelder
    dpts: ["dpst-9-1"],
  },

  // switch

  {
    id: ruleId("Button-Status-DisplaySwitch1"),
    signalType: SignalTypes.StatusDisplaySwitch,
    // ⚠ ONLY-HERE: nicht in Actor/Status
    texts: ["led"],
    dpts: ["dpst-1-1"],
  },

  {
    id: ruleId("Button-Status-DisplayColor1"),
    signalType: SignalTypes.StatusDisplayColor,
    // ⚠ ONLY-HERE: nicht in Actor/Status
    functionNames: ["led"],
    dpts: ["dpst-5-1"], // ABB 6129/01 500
  },

  {
    id: ruleId("Button-Status-DisplayColor2"),
    signalType: SignalTypes.StatusDisplayColor,
    // ⚠ ONLY-HERE: nicht in Actor/Status
    texts: ["led"],
    dpts: ["dpst-5-1"], // ABB 6129/01 500
  },

  {
    id: ruleId("Button-Status-Switch1"),
    signalType: SignalTypes.SwitchStatus,
    functionNames: ["status", "toggle", "value", "on/off", "off/on"], // "led" for MDT Glasstaster BE-xx etc.
    excludeFunctionNames: ["output ", "color", "send", "enable"],
    excludeTexts: [
      "button operation",
      "error", // abb  SBC/U6.0.1
      "heating",
    ],
    dpts: ["dpst-1-1", "dpst-1-8", "dpst-1-9", "dpst-1-11"],
  },

  //// Environment
  //

  // Forced Control 1
  {
    id: ruleId("Button-Status-ForcedConrol1"),
    signalType: SignalTypes.ForcedControlStatus,
    // ⚠ ONLY-HERE: nicht in Actor/Status
    functionNames: ["status"],
    dpts: ["dpst-2-1"],
  },

  /// Time & Date
  {
    id: ruleId("Button-Status-Environment1"),
    signalType: SignalTypes.Time,
    dpts: ["dpst-10-1"],
  },
  {
    id: ruleId("Button-Status-Environment11"),
    signalType: SignalTypes.Time,
    texts: ["time"],
    dpts: ["@ 3 bytes"],
  },
  {
    id: ruleId("Button-Status-Environment12"),
    signalType: SignalTypes.Time,
    functionNames: ["time"],
    dpts: ["@ 3 bytes"],
  },

  {
    id: ruleId("Button-Status-Environment21"),
    signalType: SignalTypes.Date,
    texts: ["date"],
    dpts: ["@ 3 bytes"],
  },
  {
    id: ruleId("Button-Status-Environment22"),
    signalType: SignalTypes.Date,
    functionNames: ["date"],
    dpts: ["@ 3 bytes"],
  },

  {
    id: ruleId("Button-Status-Environment2"),
    signalType: SignalTypes.Date,
    dpts: ["dpst-11-1"],
  },
  {
    id: ruleId("Button-Status-Environment3"),
    signalType: SignalTypes.DateTime,
    dpts: ["dpst-19-1"],
  },

  {
    // MDT SCN-LCDGx.01
    id: ruleId("Button-Status-Environment3a"),
    signalType: SignalTypes.DateTime,
    texts: ["date and time"],
    dpts: ["@ 8 bytes"],
  },

  {
    id: ruleId("Button-Status-Environment4a"),
    signalType: SignalTypes.DayNight,
    functionNames: ["day", "night"],

    dpts: ["dpst-1-1", "dpst-1-2", "dpst-1-24"],
  },
  {
    id: ruleId("Button-Status-Environment4b"),
    signalType: SignalTypes.DayNight,

    texts: [/day.*night/],
    dpts: ["dpst-1"],
  },

  // Environment Helligkeit
  {
    id: ruleId("Button-Status-Environment5"),
    signalType: SignalTypes.EnvironmentBrightness, // in LUX
    // ⚠ ONLY-HERE: nicht in Actor/Status
    functionNames: ["input"],
    dpts: ["dpst-9-4"],
  },

  // Environment Temperature
  {
    id: ruleId("Button-Status-Environment6"),
    signalType: SignalTypes.EnvironmentTemperature,
    functionNames: ["outdoor temperature"],
    dpts: ["dpst-9-1"],
  },
  // Environment Luftfeuchtigkeit
  {
    id: ruleId("Button-Status-Environment7"),
    signalType: SignalTypes.EnvironmentHumidity,
    // ⚠ ONLY-HERE: nicht in Actor/Status
    functionNames: ["humidity"],
    dpts: ["dpst-9-7"], //BE-TAS60T4.01
  },

  //lock

  // MWE 4.11.2025
  //
  // Achtung:
  //   bei Buttons ist das LockSignal sozusagen **umgekehrt** !
  //   dh. heißt:
  //       das Locksignal wird empfangen und nicht gesendet, also wie eine Statussignal
  //       ggfls ist (a.TransmitFlag == "Disabled") und wir kommen zwingend ind den Status Zweig
  //
  //
  //  Bezüglich des LockSignals verhält sich den Button also eher wie ein Aktor-Kanal
  //
  {
    id: ruleId("Button-Status-Lock1"),
    signalType: SignalTypes.ButtonLock,
    // ⚠ ONLY-HERE: nicht in Actor/Status
    functionNames: ["lock"],
    dpts: ["dpst-1-3", "dpst-1-11"],
    excludeFunctionNames: ["screen"],
  },
  {
    id: ruleId("Button-Status-Lock2"),
    signalType: SignalTypes.ButtonLock,
    // ⚠ ONLY-HERE: nicht in Actor/Status
    texts: ["locking"],
    dpts: ["dpst-1-11"],
  },
  {
    id: ruleId("Button-Status-SelectMode1"),
    signalType: SignalTypes.OperationMode_Status,
    excludeFunctionNames: ["forced"],
    dpts: ["dpst-20-102"],
  }, // DPT HVAC Mode ‐ Betriebsartvorwahl  Das Kommunikationsobjekt Betriebsartvorwahl hat die Größe 1 Byte und entspricht dem DPT 20.102-DPT HVAC Mode. Folgende Werte sind für die einzelnen Betriebsarten hinterlegt:Betriebsartvorwahl (HVAC Mode) Hex‐Wert Komfort 0x01 Standby 0x02 Nacht 0x03  Frost/Hitzeschutz 0x04

  //Alarm
  {
    id: ruleId("Button-Status-Alarm1"),
    signalType: SignalTypes.EnvironmentWindAlarm,
    functionNames: ["wind"],
    dpts: ["dpst-1-5"],
  },
  {
    id: ruleId("Button-Status-Alarm1b"),
    signalType: SignalTypes.EnvironmentFrostAlarm,
    // ⚠ ONLY-HERE: nicht in Actor/Status
    functionNames: ["frost"],
    dpts: ["dpst-1-5"],
  },
  {
    id: ruleId("Button-Status-Alarm1c"),
    signalType: SignalTypes.EnvironmentRainAlarm,
    functionNames: ["rain"],
    dpts: ["dpst-1"],
  },
  {
    id: ruleId("Button-Status-Alarm1a"),
    signalType: SignalTypes.EnvironmentRainAlarm,
    texts: ["rain"],
    dpts: ["dpst-1"],
  },
  {
    id: ruleId("Button-Status-Alarm3"),
    signalType: SignalTypes.Alarm,
    functionNames: ["exceeded", "below", "alarm", "contact", "failure", "warning", "error"],
    dpts: ["dpst-1-5"],
  },
  {
    id: ruleId("Button-Status-Alarm1_2"),
    signalType: SignalTypes.Alarm,
    texts: ["alarm"],
    dpts: ["dpst-1-5", "dpst-1-1", "dpst-1-3"],
  },
  {
    id: ruleId("Button-Status-Alarm2"),
    signalType: SignalTypes.Alarm,
    texts: [
      "error", // abb  SBC/U6.0.1
    ],
    dpts: ["dpst-1-1"],
  },

  // Logic
  {
    id: ruleId("Button-Status-Logic1"),
    signalType: SignalTypes.Switch,
    functionNames: ["input"],
    dpts: ["dpst-1-2"],
  },

  {
    id: ruleId("Button-Status-Blinking1"),
    signalType: SignalTypes.BlinkingState,
    // ⚠ ONLY-HERE: nicht in Actor/Status
    functionNames: ["blinking"], // BE-20010.01
    dpts: ["dpst-1-11"],
  },

  ///
  {
    id: ruleId("Button-Status-Switch2"),
    signalType: SignalTypes.SwitchStatus,
    excludeFunctionNames: ["send", "enable"],
    excludeTexts: ["button operation", "led", "heating"],
    dpts: ["dpst-1-1", "dpst-1-11"],
  },

  {
    id: ruleId("Button-Status-Switch3"),
    signalType: SignalTypes.Switch,
    functionNames: ["send"], // dirty hack for BE-GBZx.01 (send Status)
    dpts: ["dpst-1-1"], //BE-GBZx.01
  },
  ////// scene default
  {
    id: ruleId("Button-Status-SceneDefault1"),
    signalType: SignalTypes.Scene,
    // ⚠ ONLY-HERE: nicht in Actor/Status
    functionNames: ["scene"],
  },
  {
    id: ruleId("Button-Status-SceneDefault2"),
    signalType: SignalTypes.Scene,
    // ⚠ ONLY-HERE: nicht in Actor/Status
    texts: ["scene"],
  },
  {
    id: ruleId("Button-Status-actual-temperatur"),
    signalType: SignalTypes.Temperature_CurrentDisplay,
    // ⚠ ONLY-HERE: nicht in Actor/Status
    functionNames: [
      "status actual temperature", // MDT Glasstaster
      "external temperature sensor", // GVS Waltz Touch Plus
    ],
  },
  // {
  //   id: ruleId("Button-status-actual-temperatur"),
  //   signalType: SignalTypes.Temperature_Current,
  // ⚠ ONLY-HERE: nicht in Actor/Status
  //   texts: ["input"],
  //   dpts: ["dpst-9-1"],
  // },
  {
    //
    // lstouch
    //
    id: ruleId("Button-Status-TargetShift9"),
    signalType: SignalTypes.Temperature_TargetShift_9_Status,
    texts: ["input"],
    functionNames: ["setpoint adjustment"],
    dpts: ["dpst-9-2"],
  },
  {
    //
    // lstouch
    //
    id: ruleId("Button-Status-TargetShift6"),
    signalType: SignalTypes.Temperature_TargetShift_6_Status,
    texts: ["input"],
    functionNames: ["setpoint adjustment"],
    dpts: ["dpst-6-10"],
  },
];

export const buttonStatusSensitiv: Array<NameListEntry> = [
    {
    id: ruleId("Button-Status-sensitiv-operationmode"),
    signalType: SignalTypes.OperationMode,
    excludeTexts: ["status"],
    excludeFunctionNames: ["status"],
    dpts: ["dpst-20-102"],
    channelType: [
      ChannelType.Heating,
    ],
  },
  //state for display

  {
    id: ruleId("Button-Status-sensitiv-Switch1"),
    signalType: SignalTypes.SwitchStatus,
    oldSignalType: SignalTypes.Unknown,
    dpts: ["dpst-1-1"],
    channelType: [ChannelType.Switch],
  },

  {
    id: ruleId("Button-Status-sensitiv-Dimmer1"),
    signalType: SignalTypes.DimValueStatus,
    oldSignalType: SignalTypes.Unknown,
    dpts: ["dpst-5-1"],
    channelType: [
      ChannelType.Dimmer,
      ChannelType.Switch, // to enable "upgade" from switch to dimmer for ets Import
    ],
  },

  {
    id: ruleId("Button-Status-sensitiv-Jalousie1"),
    signalType: SignalTypes.BlindPositionStatus,
    oldSignalType: SignalTypes.Unknown,
    dpts: ["dpst-5-1"],
    excludeFunctionNames: ["slat"],
    channelType: [ChannelType.Jalousie, ChannelType.Blind],
  },
  {
    id: ruleId("Button-Status-sensitiv-Heating2"),
    signalType: SignalTypes.EnvironmentTemperature,
    oldSignalType: SignalTypes.Unknown,
    texts: ["outside"],
    dpts: ["dpst-9-1"],
    channelType: [ChannelType.Heating, ChannelType.TemperatureSetpoint, ChannelType.TemperatureMeasurement],
  },
  {
    id: ruleId("Button-Status-sensitiv-Heating1"),
    signalType: SignalTypes.Temperature_Current,
    // ⚠ ONLY-HERE: nicht in Actor/Status
    oldSignalType: SignalTypes.Unknown,
    excludeTexts: ["input", "setpoint", "set", "external", "display", "brightness", "control", "indicator"], // "control", "indicator" z41 lite
    dpts: ["dpst-9-1"],
    channelType: [ChannelType.Heating, ChannelType.TemperatureSetpoint, ChannelType.TemperatureMeasurement],
  },
  {
    id: ruleId("Button-Status-sensitiv-Heating1"),
    signalType: SignalTypes.Temperature_Current,
    // ⚠ ONLY-HERE: nicht in Actor/Status
    oldSignalType: SignalTypes.Unknown,
    functionNames: ["external temperaturee sensor"],
    channelType: [ChannelType.Heating, ChannelType.TemperatureSetpoint, ChannelType.TemperatureMeasurement],
  },
];
